import React from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import Form from "../../../components/forms/LoginForms";
import { loginAction } from "../../../../../utils/login";

const onSubmit = loginAction(
  "/podpurny-organ/api/auth/basic",
  "/podpurny-organ/funkcionari",
);

const ConnectedForm = connect(null, { onSubmit, goBack })(Form);

const OvmLogin = ({ location: { query } }) => (
  <>
    <ConnectedForm
      jipButton
      role={"ovm"}
      query={query}
      title="Přihlášení podpůrného orgánu"
    />

    <div className="publicLoginSupport">
      <div className="publicLoginSupport__row">
        Podpora pro uživatele:{" "}
        <a
          className="publicLoginSupport__email"
          href="mailto:cro@msp.justice.cz"
        >
          cro@msp.justice.cz
        </a>
      </div>
      <a
        className="publicLoginSupport__faq"
        href="https://justice.cz/web/msp/casto-kladene-otazky"
      >
        Často kladené dotazy (FAQ)
      </a>
    </div>
  </>
);

export default OvmLogin;
